<template>
  <div class="container">
    <div>
      <el-form
        inline
        size="mini"
        label-width="100px"
        class="table-search-part"
        @submit.native.prevent="handleQuery()"
      >
        <div>
          <div
            style="display: flex; justify-content: space-between; width: 100%"
          >
            <el-form-item>
              <el-form-item label="Block Type	">
                <el-select
                  v-model="queryData.type"
                  filterable
                  clearable
                  placeholder="Block Type"
                  :popper-append-to-body="false"
                >
                  <el-option value="1" label="Block"></el-option>
                  <el-option value="2" label="Reverse Block"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="Sport">
                <el-select
                  v-model="queryData.sportId"
                  filterable
                  placeholder="Sport"
                  :popper-append-to-body="false"
                >
                  <el-option value label="All"></el-option>
                  <el-option
                    v-for="item in sportList"
                    :key="Number(item.code)"
                    :label="item.value"
                    :value="Number(item.code)"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="Region ID" style="margin-right: 10px">
                <el-input
                  v-model="queryData.regionId"
                  placeholder="Region ID"
                  clearable
                ></el-input>
              </el-form-item>
              <el-form-item label="Tournament ID" style="margin-right: 10px">
                <el-input
                  v-model="queryData.leagueId"
                  placeholder="Tournament ID"
                  clearable
                ></el-input>
              </el-form-item>
              <el-form-item label="Tournament Risk LV" label-width="140px" style="margin-right: 10px">
                <el-input
                  v-model="queryData.leagueRiskLevelId"
                  placeholder="Tournament Risk LV"
                  clearable
                ></el-input>
              </el-form-item>
              <!-- <el-form-item label="Tournament" style="margin-right: 10px;">
                <el-input v-model="queryData.ip" placeholder="Tournament" clearable></el-input>
              </el-form-item>-->
              
            </el-form-item>
            <el-form-item>
            <el-form-item style="margin-right: 10px">
              <el-button class="search-btn" @click="handleQuery()"
                  >Search</el-button
                >
            </el-form-item>
            <el-form-item style="margin-right: 10px">
              <el-button class="search-btn" @click="handleChange(1, 1)"
                >Block</el-button
              >
            </el-form-item>
            <el-form-item style="margin-right: 10px">
              <el-button class="search-btn" @click="handleChange(1, 2)"
                >Reverse Block</el-button
              >
            </el-form-item>
            <el-form-item style="margin-right: 10px">
              <el-button
                class="search-btn"
                @click="handleChange(3, batchDeleteIds)"
                >Batch Delete</el-button
              >
            </el-form-item>
            <el-form-item>
              <el-button class="search-btn" @click="handleChange(2)"
                >History</el-button
              >
            </el-form-item>
            </el-form-item>
          </div>
        </div>
      </el-form>
    </div>
    <div class="syslog-table">
      <el-table
        ref="table"
        :data="list"
        :height="tableHeight"
        stripe
        v-loading="loading"
        header-row-class-name="table-header-row"
        @selection-change="handleSelectionChange"
        border
      >
        <template slot="empty">
          <Empty />
        </template>
        <el-table-column type="selection" width="30"> </el-table-column>
        <el-table-column prop="leagueRiskLevelId" label="Tournament Risk LV" width="140"></el-table-column>
        <el-table-column prop="regionId" label="Region ID" width="120">
          <template v-slot="{ row }">
            <div>{{ row.regionId || '-' }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="leagueId" label="Tournament ID" width="120">
          <template v-slot="{ row }">
            <div>{{ row.leagueId || '-' }}</div>
          </template>
        </el-table-column>
        <el-table-column
          label="Block Type"
          prop="type"
          min-width="120"
          align="center"
        >
          <template v-slot="{ row }">
            <div class="level-box">
              <span v-if="row.type">{{
                row.type == 1 ? "Block" : "Reverse Block"
              }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          label="Sport"
          prop="sportName"
          min-width="120"
        ></el-table-column>
        <el-table-column
          label="Region"
          prop="regionName"
          min-width="100"
          align="center"
        ></el-table-column>
        <el-table-column
          label="Tournament Name"
          prop="leagueName"
          min-width="200"
          align="center"
        >
          <template v-slot="{ row }">
            <div>{{ row.leagueName || '-' }}</div>
          </template>
        </el-table-column>
        <el-table-column
          label="Operate Time"
          prop="operateTime"
          min-width="120"
          align="center"
        >
          <template v-slot="{ row }">
            <div class="level-box">
              <span v-if="row.operateTime">{{
                formatUtc(row.operateTime)
              }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          label="Remark"
          prop="remark"
          min-width="200"
        ></el-table-column>
        <el-table-column
          label="Operator"
          prop="operatorName"
          min-width="100"
          align="center"
        ></el-table-column>
        <el-table-column label="Operation" min-width="140">
          <template v-slot="{ row }">
            <div>
              <el-button
                class="table-inner-btn view-order-btn"
                @click="handleChange(3, [buildDelete(row)])"
                >Delete</el-button
              >
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination-wrapper inline-wrapper">
        <el-pagination
          class="inline-right"
          :total="totalSyslog"
          :current-page="queryData.current"
          :page-size="queryData.size"
          :page-sizes="[50, 100, 200]"
          @current-change="changePageSyslog"
          @size-change="handleSizeChangeSyslog"
          layout="total, sizes, prev, pager, next, jumper"
        ></el-pagination>
      </div>
    </div>

    <!-- <div class="pagination-wrapper inline-wrapper">
      <el-pagination
        class="inline-right"
        :total="total"
        :current-page="queryData.current"
        :page-size="queryData.size"
        :page-sizes="[50, 100, 200]"
        @current-change="changePage"
        @size-change="handleSizeChange"
        layout="total, sizes, prev, pager, next, jumper"
      ></el-pagination>
    </div>-->
    <dia ref="dialogDom" class="label-dialog">
      <div v-if="num == 1">
        <el-form :model="form" :rules="rules" label-width="156px">
          <!-- <el-form-item label="Sport">
            <el-input disabled v-model="sportName" style="width: 220px" />
          </el-form-item> -->
          <el-form-item label="Sport" prop="sportId">
            <el-select
              v-model="form.sportId"
              filterable
              style="width: 220px"
              placeholder="Sport"
              :popper-append-to-body="false"
            >
              <el-option
                v-for="item in sportList"
                :key="Number(item.code)"
                :label="item.value"
                :value="Number(item.code)"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="Region ID">
            <div style="font-size: 12px;">Up to 50 IDs at one time</div>
            <el-input
              class="tournamentInput"
              type="textarea"
              style="width: 220px"
              v-model="form.regionId"
              :maxlength="1000"
              placeholder="Region ID"
              border
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item label="Tournament ID">
            <div style="font-size: 12px;">Up to 50 IDs at one time</div>
            <el-input
              class="tournamentInput"
              type="textarea"
              style="width: 220px"
              v-model="form.id"
              :maxlength="1000"
              placeholder="Tournament ID"
              border
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item label="Tournament Risk LV">
            <div style="font-size: 12px;">Up to 50 IDs at one time</div>
            <el-input
              class="tournamentInput"
              type="textarea"
              style="width: 220px"
              v-model="form.leagueRiskLevelId"
              :maxlength="1000"
              placeholder="Tournament Risk LV"
              border
              clearable
            ></el-input>
          </el-form-item>
          <!-- <el-form-item label="Tournament Name">
            <el-input disabled v-model="leagueName" style="width: 220px" />
          </el-form-item> -->
          <el-form-item label="Remark">
            <el-input
              style="width: 220px"
              v-model="form.remark"
              placeholder="Remark"
            ></el-input>
          </el-form-item>
        </el-form>
        <div class="dialog-footer table-search-part">
          <el-button class="search-btn" @click="handleViewAdd()"
            >Confirm</el-button
          >
          <el-button class="clear-btn" @click="Close()">Cancel</el-button>
        </div>
      </div>
      <div v-if="num == 2">
        <el-table
          ref="table"
          :data="historyList"
          height="500"
          v-loading="loadingItem"
          header-row-class-name="table-header-row"
          border
        >
          <template slot="empty">
            <Empty />
          </template>
          <el-table-column label="Time" align="left" min-width="90">
            <template v-slot="{ row }">
              <div class="level-box">
                <span>{{ formatUtc(row.operateTime) }}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="leagueRiskLevelId" label="Tournament Risk LV" width="140"></el-table-column>
          <el-table-column prop="regionId" label="Region ID" width="120">
            <template v-slot="{ row }">
              <div>{{ row.regionId || '-' }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="leagueId" label="Tournament ID" width="120">
            <template v-slot="{ row }">
              <div>{{ row.leagueId || '-' }}</div>
            </template>
          </el-table-column>
          <el-table-column
            label="Block Type"
            prop="configType"
            min-width="120"
            align="center"
          >
            <template v-slot="{ row }">
              <div class="level-box">
                <span v-if="row.configType">{{
                  row.configType == 1 ? "Block" : "Reverse Block"
                }}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="Sport" align="center">
            <template v-slot="{ row }">
              <div class="level-box">
                <span>{{ row.sportName }}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="Region" align="center">
            <template v-slot="{ row }">
              <div>{{ row.regionName || '-' }}</div>
            </template>
          </el-table-column>
          <el-table-column label="Tournament Name" align="center">
            <template v-slot="{ row }">
              <div>{{ row.leagueName || '-' }}</div>
            </template>
          </el-table-column>
          <el-table-column label="Remark" align="center">
            <template v-slot="{ row }">
              <div>{{ row.remark }}</div>
            </template>
          </el-table-column>
          <el-table-column label="Operator" align="center">
            <template v-slot="{ row }">
              <div>{{ row.operator }}</div>
            </template>
          </el-table-column>
          <el-table-column label="Operation" align="left">
            <template v-slot="{ row }">
              <div style="text-align: left">
                {{ row.type == 1 ? (row.configType == 1 ? "Block" : "Reverse Block") : "Delete" }}
              </div>
            </template>
          </el-table-column>
        </el-table>
        <div class="pagination-wrapper inline-wrapper">
          <el-pagination
            class="inline-right"
            :total="totalAert"
            :current-page="queryLogData.current"
            :page-size="queryLogData.size"
            :page-sizes="[50, 100, 200]"
            @current-change="changePage"
            @size-change="handleSizeChange"
            layout="total, sizes, prev, pager, next, jumper"
          ></el-pagination>
        </div>
        <div class="dialog-footer table-search-part" style="padding-top: 20px">
          <el-button class="clear-btn" @click="CloseHistory()"
            >Cancel</el-button
          >
        </div>
      </div>
      <!-- 删除3 -->
      <div class="dialog-footer table-search-part" v-if="num == 3">
        <el-form :model="delForm" label-width="56px">
          <el-form-item label="Remark" class="del-label">
            <el-input
              style="width: 380px"
              v-model="delForm.delRemark"
              placeholder="Remark"
            ></el-input>
          </el-form-item>
        </el-form>
        <el-button class="search-btn" @click="deleteCon()">Confirm</el-button>
        <el-button class="clear-btn" @click="Close()">Cancel</el-button>
      </div>
    </dia>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import dia from "@/components/dialog/index";
import Empty from "@/components/empty/index";
import {
  addConfig,
  configList,
  deleteConfig,
  LogConfigList,
  leagueConfigId,
} from "@/api/channel";
import { getTcsSportList } from "@/api/memberDetail";
export default {
  name: "TournamentConfig",
  data() {
    return {
      list: [],
      num: "",
      historyList: [],
      loading: false,
      loadingItem: false,
      totalAert: 0,
      delForm: {
        delRemark: "",
      },
      delId: [],
      form: {
        id: "",
        remark: "",
        sportId: "",
        regionId: "",
        leagueRiskLevelId: ""
      },
      leagueName: "",
      sportName: "",
      queryData: {
        leagueId: "",
        merchantId: "",
        type: "",
        sportId: "",
        leagueRiskLevelId: "",
        current: 1,
        size: 50,
      },
      queryLogData: {
        merchantId: "",
        current: 1,
        size: 50,
      },
      btnStatus: false,
      tableHeight: window.innerHeight,
      totalSyslog: 0,
      sportList: [],
      batchDeleteIds: [],
      blcokType: 1,
      rules: {
        sportId: { required: true, trigger: ["blur", "change"] }
      }
    };
  },
  methods: {
    buildDelete(item) {
      let _obj = {}
        if(item.leagueId){
          _obj.leagueId = item.leagueId
        }
        if(item.regionId){
          _obj.regionId = item.regionId
        }
        if(item.sportId){
          _obj.sportId = item.sportId
        }
        if(item.leagueRiskLevelId){
          _obj.leagueRiskLevelId = item.leagueRiskLevelId
        }
        return _obj
    },
    handleSelectionChange(val) {
      this.batchDeleteIds = val.map((item) => {
        return this.buildDelete(item)
      });
    },
    async getSportList() {
      try {
        const res = await getTcsSportList({ matchType: '' });
        const data = res.data || [];
        this.sportList = data;
        // this.sportList = Object.values(data).filter(
        //   e =>
        //     e.sportId == 1 ||
        //     e.sportId == 3 ||
        //     e.sportId == 5 ||
        //     e.sportId == 13
        // );
      } catch (error) {
        this.sportList = [];
      }
    },
    async getList() {
      this.queryData.merchantId = this.$route.query.merchantId;
      this.loading = true;
      try {
        const res = await configList(this.queryData);
        if (res.data) {
          const data = res.data || {};
          this.list = data.page.records || [];
          this.totalSyslog = data.page.total;
        } else {
          this.$message({ message: res.message, type: "warning" });
        }
        this.loading = false;
      } catch (error) {
        this.list = [];
        this.loading = false;
      }
    },
    async getLogList() {
      this.queryLogData.merchantId = this.$route.query.merchantId;
      this.loadingItem = true;
      try {
        const res = await LogConfigList(this.queryLogData);
        if (res.data) {
          const data = res.data || {};
          this.historyList = data.records || [];
          this.totalAert = data.total;
        } else {
          this.$message({ message: res.message, type: "warning" });
        }
        this.loadingItem = false;
      } catch (error) {
        this.historyList = [];
        this.loadingItem = false;
      }
    },
    async searchId(id) {
      if (!id) {
        this.leagueName = "";
        this.sportName = "";
        return;
      }
      if (!Number(id)) {
        this.$message({
          message: "Tournament ID Is Incorrect",
          type: "warning",
        });
        return;
      }
      try {
        this.btnStatus = true;
        const res = await leagueConfigId({ id: id });
        if (res.data) {
          const data = res.data || [];
          this.leagueName = data.leagueName;
          this.sportName = data.sportName;
        } else {
          this.$message({ message: res.message, type: "warning" });
        }
        this.btnStatus = false;
      } catch (error) {
        this.list = [];
        this.btnStatus = false;
      }
    },
    handleChange(num, data) {
      this.num = num;
      if (num == 1) {
        // 添加
        this.form.id = "";
        this.form.sportId = "";
        this.form.remark = "";
        this.form.regionId = "";
        this.form.leagueRiskLevelId ="";
        this.title = "Block Tournament";
        if (data == 2) {
          this.title = "Reverse Block Tournament";
        }
        this.blcokType = data;
        this.$refs["dialogDom"].isShowDia(this.title, true, "500px");
      } else if (num == 2) {
        // 添加2
        this.title = "Tournament History";
        this.getLogList();
        this.$refs["dialogDom"].isShowDia(this.title, true, "1000px");
      } else if (num == 3) {
        // 删除
        if (!data || !data.length) {
          this.$message({
            message: "Please Select",
            type: "warning",
          });
          return;
        }
        this.title = "Delete Tournament?";
        if (data.length > 1) {
          this.title = "Batch Delete Tournament?";
        }
        this.delId = data;
        this.$refs["dialogDom"].isShowDia(this.title, true, "500px");
      }
    },
    // 添加
    async handleViewAdd() {
      if (!this.form.sportId) {
        this.$message({
          message: "Please Select Sport",
          type: "warning",
        });
        return;
      }
      if (!this.form.id.trim() && !this.form.regionId.trim() && !this.form.leagueRiskLevelId.trim()) {
        this.$message({
          message: "Please Input Region ID Or Tournament ID Or Tournament Risk LV",
          type: "warning",
        });
        return;
      }
      // if (!Number(this.form.id)) return;
      // if (!this.btnStatus) {
      //   if (!this.leagueName && !this.sportName) {
      //     this.$message({
      //       message: "Tournament ID Is Incorrect",
      //       type: "warning"
      //     });
      //     return;
      //   }
      // }
      let param = {
        merchantId: this.$route.query.merchantId,
        sportId: this.form.sportId,
        remark: this.form.remark,
        type: this.blcokType,
      };
      if(this.form.id.trim()){
        param.leagueIds = this.form.id.trim().split(",");
      }
      if(this.form.regionId.trim()){
        param.regionIds = this.form.regionId.trim().split(",");
      }
      if(this.form.leagueRiskLevelId.trim()){
        param.leagueRiskLevelIds = this.form.leagueRiskLevelId.trim().split(",");
      }

      try {
        const res = await addConfig(param);
        if (res.success) {
          this.$message({
            message: "add success",
            type: "success",
          });
          this.getList();
          this.form.id = "";
          this.form.sportId = "";
          this.form.remark = "";
        } else {
          this.$message({
            message: res.message,
            type: "warning",
            duration: 30000,
            showClose: true,
          });
        }
        this.Close();
      } catch {}
    },
    Close() {
      this.form.id = "";
      this.form.sportId = "";
      this.form.remark = "";
      this.form.regionId = "";
      this.form.leagueRiskLevelId = "";
      this.delForm.delRemark = "";
      this.delId = [];
      this.$refs["dialogDom"].isShowDia(this.title, false, "500px");
    },
    CloseHistory() {
      this.$refs["dialogDom"].isShowDia(this.title, false, "1000px");
    },
    // 搜索
    handleQuery() {
      this.queryData.current = 1;
      this.getList();
    },
    // 分页
    changePageSyslog(e) {
      this.queryData.current = e;
      this.getList();
    },
    // 列表显示条目
    handleSizeChangeSyslog(e) {
      this.queryData.size = e;
      this.queryData.current = 1;
      this.getList();
    },
    // 分页
    changePage(e) {
      this.queryLogData.current = e;
      this.getLogList();
    },
    // 列表显示条目
    handleSizeChange(e) {
      this.queryLogData.size = e;
      this.queryLogData.current = 1;
      this.getLogList();
    },
    // utc时间
    formatUtc(time) {
      if(!time) return "";
      return this.$moment(+time).format("YYYY-MM-DD HH:mm:ss");
    },
    async deleteCon(row) {
      let param = {
        merchantId: this.$route.query.merchantId,
        deletes: this.delId,
        remark: this.delForm.delRemark,
      };
      const res = await deleteConfig(param);
      if (res.success) {
        this.$message({ message: "Operate Success", type: "success" });
        this.Close();
        this.getList();
        this.delForm.delRemark = "";
        this.delId = [];
      }
    },
  },
  components: {
    dia,
    Empty,
  },
  activated() {
    this.getSportList();
    this.getList();
    this.$nextTick(() => {
      let self = this;
      self.tableHeight =
        window.innerHeight - self.$refs.table.$el.offsetTop - 94;
      window.onresize = function () {
        self.tableHeight =
          window.innerHeight - self.$refs.table.$el.offsetTop - 94;
      };
    });
  },
};
</script>

<style lang="scss" scoped>
.table-search-part {
  padding: 20px 0 0 0;
  .el-form-item--mini.el-form-item {
    margin-bottom: 18px;
  }
}
.add-new-btn {
  height: 29px;
  margin-right: 15px;
}
.el-button--mini {
  padding: 8px 11px 8px !important;
}
.last-input {
  margin: 0 20px 0 0 !important;
}
.userId-item::after {
  display: inline-block;
  content: ",";
}
.userId-item:last-child {
  &::after {
    display: none;
  }
}
.del-label {
  /deep/.el-form-item__label {
    line-height: 37px !important;
  }
}
/deep/.el-button:hover,
.el-button:focus {
  color: #24b681;
  border-color: #24b681;
  background-color: #e9f8f2;
}
.tournamentInput {
  border: 1px solid #dcdfe6 !important;
}
</style>
